// extracted by mini-css-extract-plugin
export default {"layout":"SidebarLayout_layout__+y6OY","mainContent":"SidebarLayout_mainContent__pu8db","contentArea":"SidebarLayout_contentArea__XqzOM"};